// Version : 0.0.3
// Author : Vignesh
import TrailBalanceTypes from './trailBalance.types';

/**************************** GET TRAIL BALANCE START ****************************/
export const TrailBalanceStart = (addData: any) => ({
	type: TrailBalanceTypes.GET_TRAIL_BALANCE_START,
	payload: addData,
});
export const TrailBalanceSuccess = (addData: any) => ({
	type: TrailBalanceTypes.GET_TRAIL_BALANCE_SUCCESS,
	payload: addData,
});
export const TrailBalanceFailure = (addData: any) => ({
	type: TrailBalanceTypes.GET_TRAIL_BALANCE_FAILURE,
	payload: addData,
});
export const TrailBalanceResponceReset = () => ({
	type: TrailBalanceTypes.GET_TRAIL_BALANCE_RESPONSE_RESET,
});
export const TrailBalanceResponceChanged = () => ({
	type: TrailBalanceTypes.GET_TRAIL_BALANCE_RESPONSE_CHANGED,
});
/**************************** GET TRAIL BALANCE END ****************************/
